export default __webpack_public_path__ + "static/media/icon_search.5bc637f0.svg";